<template>
  <div id="app">
    <el-container>
      <el-aside>
        <el-menu :default-active="'/views/Policymanagement'" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" style="height:100vh">
          <router-link class="roterLink" to="/views/Policymanagement">
            <el-menu-item index="/views/Policymanagement">
              证书管理
            </el-menu-item>
          </router-link>
          <router-link class="roterLink" to="/views/TemplateManagement">
            <el-menu-item index="/views/TemplateManagement">
              模板管理
            </el-menu-item>
          </router-link>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import router from "./router/index"
import Index from "./pages/index.vue";
import IndexTwo from "./pages/indexTwo.vue";


export default {
  name: "app",
  data() {
    return {
      path: '',
      isback: false,
    }
  },
  provide() {
    //提供
    return {
    };
  },
  methods: {
  },
  router,
  render: h => h(App),
  components: {
    Index,
    IndexTwo
  },
  // mounted() {
  //   this.path = this.$route.path;
  //   console.log('this.$route.path',this.$route.path)
  // },
  // watch: {
  //   $route(to, from) {
  //     this.path = to.path
  //   },
  //   '$route.path': {
  //     immediate: true,
  //     handler: function (newVal, oldVal) {
  //       if (newVal === '/pages/loginpage/login' || newVal === '/pages/loginpage/register') {
  //         this.isback = true
  //       } else{
  //         this.isback = false;
  //       }
  //     }
  //   }
  // }
};
</script>

<style>
  @import './common/font/font.css';
body {
  padding: 0;
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}


.mainBack {
  width: 100vw;
  height: 100vh;
  line-height: 0;
}

/* 每个页面主体样式 */
.main {
  width: 68.75rem;
  height: auto;
  min-height: 50rem;
  margin: auto;
}

@import './common/font/font.css';
body {
  font-family: PingFang
}

</style>


// WEBPACK FOOTER //
// src/App.vue


// WEBPACK FOOTER //
// src/App.vue